module.exports = __webpack_public_path__ + "img/egg_wind.91290c19.svg";